<template>
  <div class="k-text-search">
    <div class="search-input" :class="inputStyle">
      <i class="fa-duotone fa-magnifying-glass input-icon " aria-hidden="true"></i>
      <i class="fas fa-times reset-icon" @click="resetSearch" title="Reset search text" aria-hidden="true" />
      <input class="form-control ph-no-capture"
        :placeholder="inputPlaceholder"
        v-model="searchText"
      >
    </div>
  </div>
</template>

<style scoped>
.search-input {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input .form-control {
  padding-left: 30px;
}

.search-input.alt input {
  border: 1px solid var(--kate-type-primary);
}

.search-input.alt .input-icon {
  color: var(--kate-type-primary);
}
</style>

<script>
export default {
  props: {
    modelValue: {
      type: String,
    },
    inputPlaceholder: {
      type: String,
      required: false,
      default: 'Search...',
    },
    inputStyle: {
      type: String,
      required: false,
      default: '', // '' || 'alt'
    },
  },
  data() {
    return {
      searchText: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.searchText = this.modelValue;
    },
    searchText() {
      this.$emit('update:modelValue', this.searchText);
    },
  },
  methods: {
    resetSearch() {
      this.searchText = '';
      this.$emit('reset');
    },
  },
};
</script>
